import Cookies from 'js-cookie'
import { $, on } from '../lib/domUtils'
import { addClass, removeClass } from '../lib/classie'

const scrollToTop = () => {
  // const c = document.documentElement.scrollTop || document.body.scrollTop
  // if (c > 0) {
  //   window.requestAnimationFrame(scrollToTop)
  //   window.scrollTo(0, c - c / 8)
  // }
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

// const flagUs = document.querySelector('.flag-us')
// const flagCa = document.querySelector('.flag-ca')

if (Cookies.get('location') !== '') {
  const location = Cookies.get('location')
  let hideCountry = 'ca'
  if (location === 'ca') {
    hideCountry = 'us'
  }
  if (Cookies.get('step') === 'form-selections') {
    addClass($(`.${hideCountry}-flag`), 'hidden')
    addClass($('.country-label-text'), 'hidden')
    addClass($(`.${location}-form-terms`), 'hidden')
    removeClass($(`.${location}-form-selections`), 'hidden')
    removeClass($('.refresh-page'), 'hidden')
  }
}

function detectScroll(country) {
  if (!$('body.become-a-dealer') || $('body.become-a-dealer').length <= 0) {
    return
  }

  const usFormTerms = document.getElementById(`${country}-form-terms-container`)
  usFormTerms.addEventListener('scroll', function(e) {
    if (usFormTerms.scrollTop >= usFormTerms.scrollHeight - usFormTerms.offsetHeight - 12) {
      removeClass($(`.${country}-form-terms .${country}-agree`), 'disabled')
    }
  })

  const saleAddendumOnline = document.getElementById(
    `${country}-internet-sale-addendum-online-only`,
  )
  saleAddendumOnline.addEventListener('scroll', function(e) {
    if (
      saleAddendumOnline.scrollTop >=
      saleAddendumOnline.scrollHeight - saleAddendumOnline.offsetHeight - 12
    ) {
      removeClass($(`.${country}-continue-online-only`), 'disabled')
    }
  })

  const saleAddendumOnlineMortar = document.getElementById(
    `${country}-internet-sale-addendum-online-mortar`,
  )
  saleAddendumOnlineMortar.addEventListener('scroll', function(e) {
    if (
      saleAddendumOnlineMortar.scrollTop >=
      saleAddendumOnlineMortar.scrollHeight - saleAddendumOnlineMortar.offsetHeight - 12
    ) {
      removeClass($(`.${country}-continue-online-brick-mortar`), 'disabled')
    }
  })
}

detectScroll('us')
detectScroll('ca')

function startForm(country) {
  let hideCountry = 'ca'
  if (country === 'ca') {
    hideCountry = 'us'
  }

  if ($('.refresh-page')) {
    on($('.refresh-page'), 'click', () => {
      Cookies.remove('location')
      Cookies.remove('step')
      window.location.reload()
    })
  }

  // 1. Selecting Flag
  on($(`.${country}-flag`), 'click', () => {
    removeClass($(`.${country}-form-terms`), 'hidden')
    addClass($(`.${hideCountry}-flag`), 'hidden')
    addClass($('.country-label-text'), 'hidden')
    Cookies.set('location', country)
  })

  // 2. Agree or disagree
  on($(`.${country}-not-agree`), 'click', () => {
    removeClass($(`.${hideCountry}-flag`), 'hidden')
    removeClass($('.country-label-text'), 'hidden')
    addClass($(`.${country}-form-terms`), 'hidden')
  })

  on($(`.${country}-agree`), 'click', () => {
    addClass($(`.${country}-form-terms`), 'hidden')
    removeClass($(`.${country}-form-selections`), 'hidden')
    removeClass($('.refresh-page'), 'hidden')
    scrollToTop()
    Cookies.set('step', `form-selections`)
  })

  // 3. Select form type
  on($(`.${country}-form-brick-mortar`), 'click', () => {
    addClass($(`.${country}-form-selections`), 'hidden')
    removeClass($(`.${country}-form-brick-mortar-application`), 'hidden')
  })

  on($(`.${country}-form-online-only`), 'click', () => {
    addClass($(`.${country}-form-selections`), 'hidden')
    removeClass($(`.${country}-form-addendum-online-only`), 'hidden')
  })

  on($(`.${country}-form-brick-mortar-online`), 'click', () => {
    addClass($(`.${country}-form-selections`), 'hidden')
    removeClass($(`.${country}-form-addendum-brick-mortar-online`), 'hidden')
  })

  // 4. Online agreement
  on($(`.${country}-back-to-mortar`), 'click', () => {
    addClass($(`.${country}-form-addendum-online-only`), 'hidden')
    removeClass($(`.${country}-form-selections`), 'hidden')
  })

  on($(`.${country}-back-to-mortar-online`), 'click', () => {
    addClass($(`.${country}-form-addendum-brick-mortar-online`), 'hidden')
    removeClass($(`.${country}-form-selections`), 'hidden')
  })

  // Continue with form
  on($(`.${country}-continue-online-only`), 'click', () => {
    addClass($(`.${country}-form-addendum-online-only`), 'hidden')
    scrollToTop()
    removeClass($(`.${country}-form-online-application`), 'hidden')
  })

  on($(`.${country}-continue-online-brick-mortar`), 'click', () => {
    addClass($(`.${country}-form-addendum-brick-mortar-online`), 'hidden')
    scrollToTop()
    removeClass($(`.${country}-form-online-brick-mortar-application`), 'hidden')
  })
}

startForm('us')
startForm('ca')
